import { useEffect, useId, useRef } from 'react';

/** Native HTML dialog supplies focus containment and Escape handling across browsers. */
export function ConfirmDialog({
  message,
  action,
  onConfirm,
  onCancel,
}: {
  message: string;
  action: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const id = useId();
  useEffect(() => {
    const dialog = ref.current!;
    dialog.showModal();
    return () => dialog.close();
  }, []);
  return (
    <dialog
      className="progress-confirmation"
      ref={ref}
      aria-labelledby={id}
      onCancel={(event) => {
        event.preventDefault();
        onCancel();
      }}
    >
      <p id={id}>{message}</p>
      <div>
        <button autoFocus onClick={onCancel}>
          Go back
        </button>
        <button onClick={onConfirm}>{action}</button>
      </div>
    </dialog>
  );
}
